import React from 'react'

class InterestRate extends React.Component {
  render() {
    const {
      interestType,
      fixedRateLabel,
      variableRateLabel,
    } = this.props

    return(
      <div>
        {
          (interestType === 'fixed') && (
            <p>Fixed rate of {fixedRateLabel} p.a.</p>
          )
        }
        {
          (interestType === 'variable') && (
            <p>Variable rate of {variableRateLabel} p.a.</p>
          )
        }
      </div>
    )
  }
}

export default InterestRate
